import { getChartPalette } from "../theme";
import type { ChartContext } from "./context";

export function buildPieOption(context: ChartContext): Record<string, unknown> {
  const { spec, chartType, data, isDark, translateNode, unitText, ct, base } =
    context;
  const ds = data.datasets[0];
  if (!ds) return base;
  const values = ds.values as number[];
  const isDonut = chartType === "donut";
  const colors = getChartPalette(isDark, data.labels.length);
  return {
    ...base,
    tooltip: {
      trigger: "item",
      backgroundColor: ct.bgElevated,
      borderColor: ct.border,
      formatter: (params: { name: string; value: number; percent: number }) => {
        const p = params as unknown as Record<string, unknown>;
        const val = typeof p.value === "number" ? p.value : Number(p.value);
        const pct = typeof p.percent === "number" ? p.percent : 0;
        return (
          translateNode(String(p.name)) +
          ": " +
          unitText(val) +
          " (" +
          pct.toFixed(1) +
          "%)"
        );
      },
    },
    series: [
      {
        type: "pie",
        top: spec.showTitle === false ? 8 : 55,
        data: data.labels.map((name, i) => ({
          name,
          value: values[i] ?? 0,
          itemStyle: { color: colors[i % colors.length] },
        })),
        ...(isDonut ? { radius: ["40%", "70%"] } : {}),
        label: {
          show: true,
          formatter: (p: { name: string; percent: number }) =>
            `${translateNode(p.name)}: ${p.percent}%`,
          color: ct.color,
          textBorderColor: "transparent",
          textBorderWidth: 0,
        },
        emphasis: {
          label: {
            show: true,
            color: ct.color,
            textBorderColor: "transparent",
            textBorderWidth: 0,
            fontWeight: "bold",
          },
        },
      },
    ],
  };
}
